module.exports = __webpack_public_path__ + "img/ZTOExpress.21bf2cc1.jpg";